module.exports = __webpack_public_path__ + "static/img/pro-5-220x294.9953b9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/pro-5-220x294.jpg
// module id = hCgn
// module chunks = 1